import * as crypto from 'node:crypto';

export function generateCodeVerifier(): string {
  return crypto.randomBytes(32).toString('base64url');
}

export function generateCodeChallenge(verifier: string): string {
  return crypto.createHash('sha256').update(verifier).digest().toString('base64url');
}

export function generateState(): string {
  return crypto.randomBytes(16).toString('base64url');
}
